import { Api } from '@bimdata/client';

let api: Api | null = null;

export default (): Api => { 
  if (!api) {
    api = Api.instance(import.meta.env.VITE_ADMIN_API_ENDPOINT, '0.0.1');
  }
  return api;
};
